const Divider = () => {
  return <div className="border-t border-primary" />;
};

export default Divider;
